export const contentConstant = {
    SEARCH_FAIL: 'SEARCH_CONTENT_FAIL',
    SEARCH_SUCCESS: 'SEARCH_CONTENT_SUCCESS',
    SEARCH_REQUEST: 'SEARCH_CONTENT_REQUEST',
    PAGINATE_FAIL: 'PAGINATE_CONTENT_FAIL',
    PAGINATE_SUCCESS: 'PAGINATE_CONTENT_SUCCESS',
    PAGINATE_REQUEST: 'PAGINATE_CONTENT_REQUEST',
};

export default contentConstant;